<template>
  <div>
    <div class="head-box">
      <h4>退货审核</h4>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入供应商"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <!-- v-if="osg.has('Materials,new')" -->
        <!-- <el-button
            v-if="osg.has('PurchaseReturns,assign')"
            type="primary"
            @click="selectSupplier"
            class="c-m-l-10"
          >
            分派订单
          </el-button> -->
        <!-- v-if="osg.has('PurchaseOrderItems,disInvoicingConfirm')" -->
        <el-button type="primary" @click="returnReview" class="c-m-l-10">
          退货审核
        </el-button>
        <el-button
          v-if="osg.has('PurchaseReturns,export')"
          type="primary"
          class="c-m-l-10"
          @click="
            osg.doExport(
              {
                'regex:purchaseOrderId|string#or': searchValue, //采购订单id
                'regex:_id|string#or': searchValue, //发货单id
                'regex:purchaseAdress|string#or': searchValue, //收货地址
                'regex:productName|string#or': searchValue, //产品名称
                'regex:purchaseName|string#or': searchValue, //收货人
                'regex:purchasePhone|string#or': searchValue, //收货电话
                sortField: 'createTime',
                sortOrder: 'desc',
                beanName: 'purchaseOrderItem',
                title: '发货单列表'
              },
              { dynamic: true }
            )
          "
        >
          数据导出
        </el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <!-- @selection-change="selectRows" -->
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          @selection-change="selectPurchaseOrder"
          border
          @header-dragend="osg.colWidthChange"
        >
          <el-table-column type="selection" width="55" fixed></el-table-column>
          <!-- 动态列 -->
          <c-table :fields="extFields">
            <template slot="supplierId">
              <el-table-column label="供应商" width="100px" prop="supplierId" show-overflow-tooltip>
                <!-- :formatter="formatSupplierId" -->
                <!-- <template slot-scope="scope">
                        {{ formatProductList(scope.row.sendDistricts) }}
                      </template> -->
              </el-table-column>
            </template>
          </c-table>
          <el-table-column
            fixed="right"
            width="110"
            label="操作"
            v-if="
              osg.has('PurchaseReturns,edit') ||
                osg.has('PurchaseReturns,enable') ||
                osg.has('PurchaseReturns,remove')
            "
          >
            <template slot-scope="scope" v-if="osg.has('PurchaseReturns,edit')">
              <el-dropdown class="c-m-l-10">
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <!-- v-if="osg.has('Materials,edit')" -->
                  <el-dropdown-item
                    v-if="osg.has('PurchaseReturns,edit')"
                    @click.native="doEdit(scope.row)"
                  >
                    编辑
                  </el-dropdown-item>
                  <!-- <template v-if="osg.has('Materials,enable')">
                            <el-dropdown-item
                              v-if="scope.row.state == 1"
                              @click.native="doDisable(scope.row._id)"
                            >
                              禁用
                            </el-dropdown-item>
                            <el-dropdown-item v-else @click.native="doEnable(scope.row._id)">
                              启用
                            </el-dropdown-item>
                          </template> -->
                  <!-- <el-dropdown-item
                            v-if="osg.has('Materials,remove')"
                            @click.native="doRemove(scope.row._id)"
                          >
                            删除
                          </el-dropdown-item> -->
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="编辑发货单" :close-on-click-modal="false" :visible.sync="openDetail">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        @changeForm="osg.changeForm"
      ></c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave()">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>
    <!-- 选择供应商 -->
    <el-dialog title="选择供应商" :visible.sync="productDetail" :close-on-click-modal="false">
      <div class="c-flex c-flex-between c-flex-item"></div>
      <el-form :formData="supplierForm">
        <el-form-item label="供应商名称" label-width="120">
          <el-select
            filterable
            v-model="supplierForm.supplierId"
            :remote-method="getSupplier"
            :clearable="true"
            remote
            reserve-keyword
            placeholder="请选供应商"
          >
            <el-option
              v-for="item in supplierData"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="doSupplier()">确 定</el-button>
        <el-button @click="cancelSupplier()">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'PurchaseReturns',
  data() {
    window.$this = this;
    return {
      type: '',
      tenantId: '',
      loginOrgId: '',
      name: 'purchaseOrderItem',
      refresh: true,
      fpi: {},
      selectedRows: [],
      searchValue: '',
      openDetail: false,
      productDetail: false,
      formData: {
        address: '',
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        codecfg_unit: { codeId: 'UNIT' },
        codecfg_productType: { codeId: 'productType' },
        codecfg_productProperty: { codeId: 'productProperty' },
        codecfg_agelimit: { codeId: 'agelimit' },
        cascadeCode_repairParts: { codeId: 'repairParts' }
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        // downloadUrl: this.osg.downloadUrl,
        downloadUrl: window.$this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false,
        // 新增
        limit: 10
      },
      product: {
        // productForm: {
        //   productId: '',
        //   count: ''
        // },
        exts: {
          count: ''
        },
        productList: [], //勾选中的产品
        productData: [], //查出的产品
        selectedRows: [],
        notAddedFpi: {
          data: []
        }
      },
      supplierForm: {
        supplierId: ''
      },
      supplierData: [] //服务商
    };
  },
  mounted() {
    // 当前用户tenantId
    let account = JSON.parse(sessionStorage['loginAccount']);
    this.tenantId = account.tenantId;
    this.loginOrgId = account.orgId;

    this.doInit();
    this.osg.getFields('purchaseOrderItem', () => {
      this.osg.getFpi();
      this.getData();
    });
  },
  methods: {
    formatCascade(option, arr) {
      let str = '';
      let opts = this.$util.deepCopy(this.options[option]);
      // 单选级联 有几级循环几次
      for (var i = 0; i < arr.length; i++) {
        for (var opt of opts) {
          if (opt.value == arr[i]) {
            str += (opt.label || opt.name) + '、';
            opts = this.$util.deepCopy(opt.children);
            break;
          }
        }
      }
      return str.slice(0, str.length - 1);
    },
    // 单位
    formatUnit(row, column, cellValue) {
      return this.osg.codelabel('unit', cellValue);
    },
    // 产品类型
    formatProductType(row, column, cellValue) {
      return this.osg.codelabel('productType', cellValue);
    },
    // 产品属性
    formatProductProperty(row, column, cellValue) {
      return this.osg.codelabel('productProperty', cellValue);
    },
    // 最高质保年限
    formatAgelimit(row, column, cellValue) {
      return this.osg.codelabel('agelimit', cellValue);
    },
    // 维修部位
    formatRepairPart(row, column, cellValue) {
      return this.osg.formatCascadeMultiple('repairParts', cellValue);
    },
    format(option, value) {
      return this.osg.codelabel(option, value);
    },
    formatArray(option, value) {
      return this.osg.codelabelForArray(option, value);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      //
      if (this.$refs['formData']) {
        this.$refs['formData'].resetFields();
      }
      this.upload.data = {};
      this.formData = { images: [], exts: {}, address: '' };
      this.$util.renderExtField(this.extFields, this.formData);
      this.product.productList = [];
    },

    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:purchaseOrderId|string#or': this.searchValue, //采购订单id
        'regex:_id|string#or': this.searchValue, //发货单id
        'regex:productName|string#or': this.searchValue, //产品名称
        'regex:purchaseAdress|string#or': this.searchValue, //收货地址
        'regex:purchaseName|string#or': this.searchValue, //收货人
        'regex:purchasePhone|string#or': this.searchValue, //收货电话
        'is:status|string#and': '498', //发货状态 退货中

        // 'in:state|array-integer#and': '0,1',  purchasePhone
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      //添加过滤器参数
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/purchaseOrder/queryPurchaseOrderItem.do', params, res => {
        // 解析json字符串的字段
        this.$util.renderExtFields(this.extFields, res.data);
        // 赋值
        this.fpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
          // this.getProduct();
          this.getSupplier();
        });
      });
    },
    // 获取产品
    // getProduct() {
    //   let params = {
    //     page: this.fpi.page,
    //     rows: this.fpi.rows,
    //     'regex:name|string#or': this.searchValue,
    //     'regex:code|string#or': this.searchValue,
    //     'in:state|array-integer#and': '0,1',
    //     sortField: 'createTime',
    //     sortOrder: 'desc'
    //   };
    //   // if (this.tenantId != '1340835581184723420') {
    //   //   if (this.type == '3') {
    //   //     params['is:productType|string#and'] = '3';
    //   //   } else if (this.tenantId != '4551453470943235290') {
    //   //     params['in:productType|array#and'] = '1,2';
    //   //   }
    //   // }
    //   //添加过滤器参数
    //   window.$that.getParams(params);
    //   this.osg.setFpi(params);
    //   this.osg.ajax('basic/product/query.do', params, res => {
    //     res.data.map(item => {
    //       if (this.$util.isJson(item.productBizType))
    //         item.productBizType = JSON.parse(item.productBizType);
    //     });
    //     // 解析json字符串的字段
    //     this.$util.renderExtFields(this.extFields, res.data);
    //     this.product.productData = res.data;
    //     this.$nextTick(() => {
    //       this.$refs.table.doLayout();
    //       this.$forceUpdate();
    //     });
    //   });
    // },
    // 获取供应商
    getSupplier(searchVal) {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        notFilterOrgId: '1',
        notFilterBelongTo: '1',
        'regex:name|string#or': searchVal,
        'regex:phone|string#or': searchVal,
        'regex:_id|string#or': searchVal,
        // 'in:state|array-integer#and': this.state == 'archived' ? -1 : '0,1',
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      // if (this.type == 'all') {
      //   params['ne:tenantId|string#and'] = '1340835581184723420';
      // }
      //添加过滤器参数
      // $that.getParams(params);
      // this.osg.setFpi(params);
      this.osg.ajax(
        // this.type == 'all' ? 'basic/partner/queryAll.do' : 'basic/partner/query.do',
        'basic/supplier/query.do',
        params,
        res => {
          this.supplierData = res.data;
          this.$nextTick(() => {
            this.$refs.table.doLayout();
            this.$forceUpdate();
          });
          // this.getOrg();
        }
      );
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      //
      row = Object.assign({}, row); //避免编辑内容后取消导致显示异常
      this.$util.renderExtField(this.extFields, row);
      // 解析图片字段
      if (row.images) {
        if (this.$util.isJson(row.images)) {
          row.images = JSON.parse(row.images);
        }
      } else {
        row.images = [];
      }

      // this.formData = row;
      this.formData = this.$util.deepCopy(row);
      this.openDetail = true;
    },
    doSave() {
      this.formData.productList = this.product.productList;
      console.log(this.productList, '----this.productList');
      let params = this.$util.deepCopy(this.formData);
      // params.approveState = 0; //修改数据时审核状态改为0

      // 超级管理员、平台管理员、当前组织都可以看到此条数据
      // params.scopeJson = params.scopeJson || [];
      // params.scopeIds = params.scopeIds || [];
      // if (params.scopeIds.indexOf('0') == -1) params.scopeIds.push('0');
      // if (params.scopeIds.indexOf(this.tenantId) == -1) params.scopeIds.push(this.tenantId);
      // if (params.scopeIds.indexOf(this.loginOrgId) == -1) params.scopeIds.push(this.loginOrgId);

      // this.$util.saveExtField(this.extFields, row);
      this.$util.saveExtField(this.extFields, params);
      if (this.osg.validate()) {
        params.images = params.images || [];
        params.images.map(item => {
          if (item.url.indexOf('blob:') != -1) {
            item.url = this.upload.downloadUrl + item.response.key;
          }
        });
        params.images = JSON.stringify(params.images);

        this.osg.ajax(
          'basic/PurchaseOrderItems/upsert.do',
          { data: JSON.stringify(params) },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('保存成功！');
          }
        );
        this.product.productList = [];
      }
    },

    // 列表多选
    selectPurchaseOrder(rows) {
      this.selectedRows = rows;
    },
    selectSupplier() {
      if (this.selectedRows.length == 0) {
        this.osg.toast('请选择至少1条！', 'warning');
        return;
      }
      this.getSupplier();
      this.productDetail = true;
    },
    // 选择供应商
    doSupplier() {
      let params = {
        purchaseOrderItemList: this.selectedRows,
        supplierId: this.supplierForm.supplierId,
        newStatus: '102'
      };
      console.log(params, 'params');
      this.osg.ajax(
        'basic/purchaseOrder/batchingPurchaseOrderItem.do',

        { data: JSON.stringify(params) },
        () => {
          this.doInit();
          this.getData();
          this.osg.toast('分派成功！');
        }
      );
      this.selectedRows = '';
      this.productDetail = false;
    },
    cancelSupplier() {
      this.productDetail = false;
    },
    // 退货审核
    returnReview() {
      if (this.selectedRows.length == 0) {
        this.osg.toast('请选择至少1条！', 'warning');
        return;
      }
      let params = {
        purchaseOrderItemList: this.selectedRows,
        newStatus: '499'
      };
      console.log(params, 'params');
      this.osg.confirm('是否确认退货？', () => {
        this.osg.ajax(
          'basic/purchaseOrder/batchingPurchaseOrderItem.do',

          { data: JSON.stringify(params) },
          () => {
            this.doInit();
            this.getData();
            this.osg.toast('操作成功！');
            this.selectedRows = '';
          }
        );
      });
    }
  }
};
</script>
<style lang="scss">
.c-dialog {
  min-width: 1000px !important;
}
</style>
